import { render } from "./Live.vue?vue&type=template&id=3c92e8f4&scoped=true"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"

import "./Live.vue?vue&type=style&index=0&id=3c92e8f4&scoped=true&lang=less"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c92e8f4"]])

export default __exports__